// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeFilledSvg from "@fishx/icons-svg/es/asn/EyeFilled";
import FishxIcon from '../components/FishxIcon';

var EyeFilled = function EyeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeFilledSvg
  }));
};

EyeFilled.displayName = 'EyeFilled';
export default React.forwardRef(EyeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EyeFilled.js
// module id = 2645
// module chunks = 0